import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/home',
            component: () => import('@/pages/home/views/Index'),
            children: [
                {
                    name: 'Home',
                    path: '',
                    meta: {title: '방문예약'},
                    component: () => import('@/pages/home/views/Home'),
                }, {
                    name: 'TermViewer',
                    path: 'termViewer/:termsId',
                    meta: {title: '약관 보기'},
                    component: () => import('@/pages/home/views/TermViewer.vue'),
                }, {
                    name: 'AgreeTerms',
                    path: 'agreeTerms',
                    meta: {title: '약관 동의'},
                    component: () => import('@/pages/home/views/apply/AgreeTerms'),
                }, {
                    name: 'ApplyReservation',
                    path: 'applyReservation',
                    meta: {title: '방문예약 신청하기'},
                    component: () => import('@/pages/home/views/apply/ApplyReservation'),
                }, {
                    name: 'Search',
                    path: 'search',
                    meta: {title: '방문예약 조회하기'},
                    component: () => import('@/pages/home/views/search/Search'),
                }, {
                    path: 'qrcode/:encryptedVisitId/:encryptedVisitorId?',
                    component: () => import('@/pages/home/views/qrcode/Qrcode'),
                }, {
                    path: 'visitInfo/:force/:encryptedVisitId/:encryptedVisitorId', // force: 't' is true, 'f' is false
                    component: () => import('@/pages/home/views/info/VisitInfo'),
                }
            ],
        },
    ],
})

router.beforeEach(function (to, from, next) {
    window.scrollTo(0,0);
    if (to.path === '/') {
        next('/home');
    } else {
        next();
    }
})

export default router;